export enum IPackageType {
    CHOOSE = 'CHOOSE',
    QUALIFIED = 'QUALIFIED'
}